module.exports = __webpack_public_path__ + "img/icon-bar-chart-active.a7a3b73d.svg";